import { FC, memo } from "react";
import classNames from "classnames";
import TabNavigationButton from "@features/home/components/HomeCourseSlider/Tabs/TabNavigationButton";

interface Props {
  slug: string;
  isLoading: boolean;
  loadingMore: boolean;
  isEnd: boolean;
  onNavigation: (
    e: React.MouseEvent<HTMLDivElement | HTMLButtonElement>
  ) => void;
}

const DesktopNavigation: FC<Props> = memo(
  ({ slug, isLoading, loadingMore, isEnd, onNavigation }) => (
    <>
      <TabNavigationButton
        direction="left"
        className={classNames(
          "absolute disabled:opacity-0 hidden lg:flex xl:-right-6 lg:-right-2 top-[35%] z-10",
          `swiper-button-prev-${slug}`
        )}
        modeElement="button"
      />
      <TabNavigationButton
        onClick={onNavigation}
        direction="right"
        className={classNames(
          "absolute xl:-left-6 lg:-left-2 hidden lg:flex top-[35%] z-10",
          `swiper-button-next-${slug} disabled:opacity-0`,
          !loadingMore && isEnd ? "opacity-0" : "opacity-100",
          isLoading ? "!cursor-default pointer-events-none" : "!cursor-pointer"
        )}
        isLoading={isLoading || false}
        modeElement={"div"}
      />
    </>
  )
);
DesktopNavigation.displayName = "DesktopNavigation";

export default DesktopNavigation;
